module.exports = __webpack_public_path__ + "static/media/fixed-voice-info-green.5062025e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed-voice-info-green.svg
// module id = 3228
// module chunks = 0